import useCmsQuery from './useCmsQuery.tsx';
import { getCommonTranslations } from '../../cms';
import useMarketInfo from '../../hooks/useMarketInfo.tsx';

const useCommonTranslations = () => {
  const { language } = useMarketInfo();

  const { data, loading, error } = useCmsQuery(
    () => getCommonTranslations(language),
    [language],
  );

  return {
    commonTranslations: { search: data?.search || undefined },
    isLoading:          loading,
    error,
  };
};

export default useCommonTranslations;
